"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValue = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var TimeControl_styles_1 = require("./TimeControl.styles");
var moment_1 = __importDefault(require("moment"));
var SelectControl_1 = __importDefault(require("../SelectControl/SelectControl"));
var react_1 = require("react");
exports.defaultValue = {
    start: new Date(Date.now() - (1000 * 60 * 60 * 24 * 30)),
    end: new Date(),
};
var TimeControl = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "Zeitraum" : _b, value = _a.value, onChange = _a.onChange, _c = _a.aggregation, aggregation = _c === void 0 ? "hour" : _c, _d = _a.className, className = _d === void 0 ? "" : _d;
    var styles = (0, TimeControl_styles_1.useStyles)();
    var start = sanitize[aggregation](value.start, "start");
    var end = sanitize[aggregation](value.end, "end");
    var startMoment = (0, moment_1.default)(start);
    var endMoment = (0, moment_1.default)(end);
    var handleChangeDateTime = function (field) { return function (dateFormat) {
        var _a;
        onChange(__assign(__assign({}, value), (_a = {}, _a[field] = sanitize[aggregation](new Date(Date.parse(dateFormat)), field), _a)));
    }; };
    var handleChangeDate = function (field) { return function (dateFormat) {
        var _a;
        var oldDate = value[field];
        var newDate = new Date(Date.parse(dateFormat));
        newDate.setHours(oldDate.getHours());
        newDate.setMinutes(oldDate.getMinutes());
        onChange(__assign(__assign({}, value), (_a = {}, _a[field] = sanitize[aggregation](newDate, field), _a)));
    }; };
    var handleChangeHour = function (field) { return function (hour) {
        var _a;
        var date = new Date(value[field].getTime());
        date.setHours(hour);
        onChange(__assign(__assign({}, value), (_a = {}, _a[field] = sanitize[aggregation](date, field), _a)));
    }; };
    var handleChangeMonth = function (field) { return function (month) {
        var _a;
        var date = new Date(value[field].getTime());
        date.setMonth(month - 1);
        onChange(__assign(__assign({}, value), (_a = {}, _a[field] = sanitize[aggregation](date, field), _a)));
    }; };
    (0, react_1.useEffect)(function () {
        // save sanitized values
        if (value.start.toISOString() != start.toISOString()
            ||
                value.end.toISOString() != end.toISOString()) {
            onChange({ start: start, end: end });
        }
    }, [start.toISOString(), end.toISOString()]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(styles.component, " ").concat(className) }, { children: [(label === null || label === void 0 ? void 0 : label.length) > 0 ? (0, jsx_runtime_1.jsx)("div", __assign({ className: styles.label }, { children: label })) : null, (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.options }, { children: [aggregation == "minutes_1" || aggregation == "minutes_5" ?
                        (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("input", { className: styles.input, type: "datetime-local", value: startMoment.format("YYYY-MM-DDTHH:mm"), step: aggregation == "minutes_1" ? 60 : 60 * 5, onChange: function (e) { return handleChangeDateTime("start")(e.target.value); } }), (0, jsx_runtime_1.jsx)("span", __assign({ className: styles.divider }, { children: "bis" })), (0, jsx_runtime_1.jsx)("input", { className: styles.input, type: "datetime-local", value: endMoment.format("YYYY-MM-DDTHH:mm"), step: aggregation == "minutes_1" ? 60 : 60 * 5, onChange: function (e) { return handleChangeDateTime("end")(e.target.value); } })] })
                        : null, aggregation == "hour" ?
                        (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("input", { className: styles.input, type: "date", value: startMoment.format("YYYY-MM-DD"), onChange: function (e) { return handleChangeDate("start")(e.target.value); } }), (0, jsx_runtime_1.jsx)(SelectControl_1.default, { value: start.getHours(), onChange: handleChangeHour("start"), options: __spreadArray([], Array(24), true).map(function (_, index) { return ({ value: index, label: "".concat(index, " Uhr") }); }) }), (0, jsx_runtime_1.jsx)("span", __assign({ className: styles.divider }, { children: "bis" })), (0, jsx_runtime_1.jsx)("input", { className: styles.input, type: "date", value: endMoment.format("YYYY-MM-DD"), onChange: function (e) { return handleChangeDate("end")(e.target.value); } }), (0, jsx_runtime_1.jsx)(SelectControl_1.default, { value: end.getHours(), onChange: handleChangeHour("end"), options: __spreadArray([], Array(25), true).map(function (_, index) { return ({ value: index, label: "".concat(index, " Uhr") }); }) })] })
                        :
                            null, aggregation == "day" ?
                        (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("input", { className: styles.input, type: "date", value: startMoment.format("YYYY-MM-DD"), onChange: function (e) { return handleChangeDate("start")(e.target.value); } }), (0, jsx_runtime_1.jsx)("span", __assign({ className: styles.divider }, { children: "bis" })), (0, jsx_runtime_1.jsx)("input", { className: styles.input, type: "date", value: endMoment.format("YYYY-MM-DD"), onChange: function (e) { return handleChangeDate("end")(e.target.value); } })] })
                        :
                            null, aggregation == "month" ?
                        (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SelectControl_1.default, { value: start.getMonth() + 1, onChange: handleChangeMonth("start"), options: __spreadArray([], Array(12), true).map(function (_, index) { return ({
                                        value: index + 1,
                                        label: "".concat(monthLabels[index])
                                    }); }) }), (0, jsx_runtime_1.jsx)(SelectControl_1.default, { value: start.getFullYear(), onChange: function (value) { return handleChangeDateTime("start")("".concat(value, "-").concat(start.getMonth() + 1, "-01 00:00:00")); }, options: getAvailableYears().map(function (year) { return ({ value: year, label: "".concat(year) }); }) }), (0, jsx_runtime_1.jsx)("span", __assign({ className: styles.divider }, { children: "bis" })), (0, jsx_runtime_1.jsx)(SelectControl_1.default, { value: end.getMonth() + 1, onChange: handleChangeMonth("end"), options: __spreadArray([], Array(12), true).map(function (_, index) { return ({
                                        value: index + 1,
                                        label: "".concat(monthLabels[index])
                                    }); }) }), (0, jsx_runtime_1.jsx)(SelectControl_1.default, { value: end.getFullYear(), onChange: function (value) { return handleChangeDateTime("end")("".concat(value, "-").concat(end.getMonth() + 1, "-31 23:59:59")); }, options: getAvailableYears().map(function (year) { return ({ value: year, label: "".concat(year) }); }) })] })
                        :
                            null] }))] })));
};
exports.default = TimeControl;
var sanitize = {
    minutes_1: function (date, field) {
        var d = new Date(date.getTime());
        d.setMilliseconds(field == "start" ? 0 : 999);
        d.setSeconds(field == "start" ? 0 : 59);
        return d;
    },
    minutes_5: function (date, field) {
        var d = sanitize.minutes_1(date, field);
        var rest = d.getMinutes() % 5;
        d.setMinutes(rest < 3 ? d.getMinutes() - rest : d.getMinutes() + (5 - rest));
        return d;
    },
    hour: function (date, field) {
        var d = sanitize.minutes_1(date, "start");
        d.setMinutes(0);
        return d;
    },
    day: function (date, field) {
        var d = sanitize.hour(date, field);
        if (field == "end") {
            d.setMilliseconds(999);
            d.setSeconds(59);
            d.setMinutes(59);
        }
        d.setHours(field == "start" ? 0 : 23);
        return d;
    },
    month: function (date, field) {
        var d = sanitize.day(date, field);
        d.setMilliseconds(50);
        if (field == "start") {
            d.setDate(1);
        }
        else {
            var lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
            d.setDate(lastDay.getDate());
        }
        return d;
    },
    year: function (date, field) {
        var d = sanitize.month(date, field);
        d.setMonth(field == "start" ? 0 : 11);
        return d;
    }
};
var getAvailableYears = function () {
    var now = new Date();
    return __spreadArray([], Array(now.getFullYear() - 2010), true).map(function (_, index) { return 2010 + index + 1; });
};
var monthLabels = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
];
